/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlacklistedDomain
 */
export interface BlacklistedDomain {
    /**
     * 
     * @type {string}
     * @memberof BlacklistedDomain
     */
    domain?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BlacklistedDomain
     */
    domainIsARegexPattern?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BlacklistedDomain
     */
    reason?: string;
    /**
     * 
     * @type {Date}
     * @memberof BlacklistedDomain
     */
    updatedDate?: Date;
}

/**
 * Check if a given object implements the BlacklistedDomain interface.
 */
export function instanceOfBlacklistedDomain(value: object): value is BlacklistedDomain {
    return true;
}

export function BlacklistedDomainFromJSON(json: any): BlacklistedDomain {
    return BlacklistedDomainFromJSONTyped(json, false);
}

export function BlacklistedDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlacklistedDomain {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'] == null ? undefined : json['domain'],
        'domainIsARegexPattern': json['domainIsARegexPattern'] == null ? undefined : json['domainIsARegexPattern'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'updatedDate': json['updatedDate'] == null ? undefined : (new Date(json['updatedDate'])),
    };
}

export function BlacklistedDomainToJSON(value?: BlacklistedDomain | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'domain': value['domain'],
        'domainIsARegexPattern': value['domainIsARegexPattern'],
        'reason': value['reason'],
        'updatedDate': value['updatedDate'] == null ? undefined : ((value['updatedDate']).toISOString()),
    };
}

